import { makeStyles } from '@mui/styles';
import Accordion from 'apollo-react/components/Accordion';
import AccordionDetails from 'apollo-react/components/AccordionDetails';
import AccordionSummary from 'apollo-react/components/AccordionSummary';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { getSavedSearchProp } from './../selectors/editor.selectors';
import { useSavedSearchSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import CheckboxControl from '../controls/Checkbox';
import TextBoxControl from '../controls/TextBox';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  column: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 700,
    marginTop: 5,
  },
  addButtonContainer: {
    textAlign: 'right',
    paddingTop: '8px !important',
    paddingRight: '15px !important',
  },
});

const Details = () => {
  const classes = useStyles();
  const translateString = useTranslation();

  const searchNameValue = useSavedSearchSelector(getSavedSearchProp, { prop: 'searchName' });

  return (
    <Accordion defaultExpanded>
      <AccordionSummary>
        <Typography>{translateString('Details')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.root}>
        <Grid container spacing={1} flexDirection="column">
          <Grid item className={classes.firstColumn} xs={12} md={8} lg={8}>
            <div className={classes.column}>
              <TextBoxControl
                prop="searchName"
                label="Saved Search Name"
                currentValue={searchNameValue}
                required
              />
            </div>
          </Grid>
          <Grid item className={classes.firstColumn} xs={12} md={8} lg={4}>
            <div className={classes.column}>
              <CheckboxControl prop="showInDashboard" label="Show In Dashboard" />
            </div>
          </Grid>
          <Grid item className={classes.firstColumn} xs={12} md={8} lg={4}>
            <div className={classes.column}>
              <CheckboxControl
                prop="configuration.showInDropdown"
                label="Show in Entity Drop Down"
              />
            </div>
          </Grid>
          <Grid item className={classes.firstColumn} xs={12} md={8} lg={4}>
            <div className={classes.column}>
              <CheckboxControl prop="isDefault" label="System Default" />
            </div>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default Details;
